<template>
  <div class="alert_yzImg_box">
    <el-dialog
      title="请输入图形验证码"
      width="300px"
      :visible.sync="this.yzmObj.dialogVisible"
      center
      class="verify-dialog"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form @submit.native.prevent :model="ruleForm" ref="ruleForm" label-width="0">
        <div class="verification" style="text-align: center">
          <img :src="imgCode" alt title="点击更换图形验证码" @click="getImgCode" />
        </div>
        <el-form-item
          prop="verifyCode"
          :rules="[
              { required: true, message: '请输入图形验证码', trigger: 'blur' },
              ]"
        >
          <el-input
            autofocus
            placeholder="请输入图形验证码"
            style="text-align: center;margin-top: 20px"
            v-model="ruleForm.verifyCode"
            class="verification-input"
            @keyup.enter.native="submitCodeForm('ruleForm')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="flag" type="primary" @click="submitCodeForm('ruleForm')" style="width: 100%">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["yzmObj"],
  data() {
    return {
      ruleForm: {
        verifyCode: ""
      },
      imgCode: "",
      flag: false
    };
  },
  created() {
    this.getImgCode();
  },
  watch: {
    yzmObj: {
      handler: function(newVal) {
        if (newVal.dialogVisible) {
          this.getImgCode();
        }
      },
      deep: true
    }
  },
  methods: {
    submitCodeForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sendCode();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**获取图形验证码 */
    getImgCode() {
      this.api.verifyCode({ date: new Date().getTime() }).then(
        res => {
          this.imgCode = res.obj.base64;
        }
      );
    },
    /**发送验证码 */
    sendCode() {
      this.flag = true;
      let params = {
        mobile: this.yzmObj.mobile,
        type: this.yzmObj.type,
        verifyCode: this.ruleForm.verifyCode,
        active: true
      };
      this.api.sendMobileCode(params).then(res => {
        this.flag = false;
        if (res.error.err_code === 0) {
          this.$emit("setDwoncountSwitch", true);
          this.handleClose();
        } else {
          this.$emit("setDwoncountSwitch", false);
        }
        this.getImgCode();
      });
    },
    handleClose() {
      this.yzmObj.dialogVisible = false;
      this.ruleForm.verifyCode = "";
    }
  }
};
</script>

<style lang="scss">
.alert_yzImg_box {
  input {
    text-align: center;
  }
  .verify-dialog {
    width: 500px;
    margin: 0 auto;
  }

  .verify-dialog .el-dialog {
    height: 200px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto !important;
  }

  .verify-dialog .el-dialog__body .el-form {
    margin-left: 0px;
    padding: 0px;
  }

  .verify-dialog .el-dialog__body {
    padding: 10px;
  }

  .verify-dialog .el-dialog__body .verification {
    text-align: center;
    margin-bottom: 10px;
  }

  .verify-dialog .el-dialog__body .el-input {
    width: 100%;
    height: 40px;
  }

  .verify-dialog .el-dialog__body .el-input input {
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .verify-dialog .el-dialog--center .el-dialog__footer {
    padding: 0;
    overflow: hidden;
  }

  .verify-dialog .el-dialog--center .el-dialog__footer .el-button {
    border-radius: 0px;
    height: 40px;
  }
}
</style>
